import { tViews } from "../../../../../utils/table";

export default {
  get title() { return tViews('userTableHeadingTopClients'); },
  get subTitle() { return tViews('clientsTitle'); },
  legend: {
    theme: "overlay",
    labels: [
      tViews('applicationOverviewUsed'),
      tViews('applicationCircuitViewLabelPrevious')
    ]
  },
  columns: [
    {
      get title() { return tViews('clientSitesColHeader'); },
      colSpan: 1,
      property: "site_name",
      type: "string",
      format: "link",
      maxLength: 15,
      width: "40px"
    },
    {
      get title() { return tViews('clientIpColHeader'); },
      colSpan: 1,
      property: "source_ip",
      type: "string",
      format: "link",
      maxLength: 15,
      width: "105px"
    },
    {
      get title() { return tViews('clientsTopAppsColHeader'); },
      colSpan: 1,
      property: "top_used_apps",
      type: "string",
      format: "array",
      delimiter: " | ",
      maxLength: 12,
      width: "120px",
      headerEllipsis: true
    },
    {
      get title() { return tViews('userDataUsage'); },
      colSpan: 1,
      property: "usage",
      theme: "changeQuality",
      type: "bytes",
      format: "GB",
      decimal: 0,
      comboUsageChange: true,
      width: "140px",
      padding: "0px",
      headerEllipsis: true
    },
    {
      get title() { return tViews('clientDistributionColHeader'); },
      colSpan: 1,
      property: "chart",
      type: "chart",
      format: "overlayBarChart",
      width: "150px",
      padding: "0px",
      headerEllipsis: true
    }
  ]
};
